import {Component, ViewChild, OnInit, TemplateRef, EventEmitter, Output } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap';
import { ModalService } from '../../../services/modal.service';
import * as $ from 'jquery';
import { Subscription } from 'rxjs';
import { NgForm } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { TipoComunicacao } from '../../../model/tipocomunicacao';
import { CadastrosService } from '../../../services/cadastros.service';

@Component({
  selector: 'app-detalhes-tipocomunicacao',
  templateUrl: 'tipocomunicacao-detalhes.component.html'
})
export class TipoComunicacaoDetalhesComponent implements OnInit{

  @ViewChild('modaltipocomunicacao', {static: false}) public modaltipocomunicacao: ModalDirective;

  sub: boolean = false;
  _tipocomunicacao: TipoComunicacao = new TipoComunicacao();
  @Output() loadtipocomunicacao = new EventEmitter();
  titulo: string = "Novo Tipo de Comunicação";
  movSubSalvar: Subscription;
  movSubAlterar: Subscription;
  movSub: Subscription;

  constructor(
    private modalService: ModalService,
    private toastr: ToastrService,
    private cadastrosService: CadastrosService) {
  }

  ngOnInit() {

    if(this.sub == false){

      this.sub = true;

      this.modalService.modalDetalhesTipoComunicacao.subscribe(
        (p: TipoComunicacao) => {

          if(p == null){
            this.titulo = "Novo Tipo de Comunicação"
            this._tipocomunicacao = new TipoComunicacao();
          }else{
            this.titulo = "Editar Tipo de Comunicação"
            this._tipocomunicacao = p;
          }

          this.limpaModal();

          this.modaltipocomunicacao.show();

        }, error => {
          console.log(error.message);
        }
      );
    }

  }

  hideModal(){
    this.modaltipocomunicacao.hide();
    this.loadtipocomunicacao.emit();
  }

  limpaModal(){
    $('body').removeClass('modal-open');
    $('.modal-backdrop').remove();
  }

  onSubmit(form: NgForm) {

    if (!form.valid) {
      return;
    }

    if(this.titulo == "Editar Tipo de Comunicação"){
      this.atualizar();
    }else{
      this.salvar();
    }

    form.reset();
  }

  salvar(){

    let objtipocomunicacao = JSON.parse(JSON.stringify(this._tipocomunicacao));

    this.cadastrosService.salvar("tipocomunicacao/insert", objtipocomunicacao).subscribe(
      (result) =>{

        this.toastr.success('Tipo de Comunicação cadastrado com sucesso!', 'Sucesso!');
        console.log(result);

        this.hideModal();

      },
      error=> {

        this.toastr.error(error.message, 'Erro!');
        console.log(error);

        this.hideModal();
      }

    );



  }

  atualizar(){

    let objtipocomunicacao = JSON.parse(JSON.stringify(this._tipocomunicacao));

    this.cadastrosService.atualizar("tipocomunicacao/update", objtipocomunicacao, objtipocomunicacao.id).subscribe(
      (result) =>{

        this.toastr.success('Tipo de Comunicação atualizado com sucesso!', 'Sucesso!');
        console.log(result);

        this.hideModal();

      },
      error=> {

        this.toastr.error(error.message, 'Erro!');
        console.log(error);

        this.hideModal();
      }

    );
  }
}
